@if ({ show: showMobileNavVersion$ | async }; as showMobileNavVersion) {
  <div class="compound-navbar-container">
    @if (isAuthenticated$ | async) {
      <compound-top-navbar [showMobileNavVersion]="showMobileNavVersion.show"></compound-top-navbar>
      @if (!isVerticalNavigationEnabled()) {
        <compound-second-level-navbar [showMobileNavVersion]="showMobileNavVersion.show"></compound-second-level-navbar>
        @if (!isSmallViewport()) {
          <compound-third-level-navbar [showMobileNavVersion]="showMobileNavVersion.show"></compound-third-level-navbar>
        }
      }
    } @else {
      <compound-top-navbar-unauthenticated
        [showMobileNavVersion]="showMobileNavVersion.show"
      ></compound-top-navbar-unauthenticated>
    }
  </div>
}
